<div class="setting-row">
    <div class="left-section">
        <div class="icon-circle">
            <i [class]="getIconClass()" aria-hidden="true"></i>
        </div>
        <div class="text-block">
            <div class="title">{{ title }} @if (statusType === 'review' && !configured) {
<span
                    class="default-text">(Default)</span>
}</div>
            <div class="description">{{ description }}</div>
        </div>
    </div>

    <div class="right-section">
        <app-button [label]="getButtonLabel()" [color]="getButtonColor()" (clicked)="onButtonClick()"
            [iconBefore]="getButtonIconClass()"></app-button>
    </div>
</div>